module.exports = __webpack_public_path__ + "img/qshk.0926f08c.png";